import script from "./VariablesContent.vue?vue&type=script&setup=true&lang=js"
export * from "./VariablesContent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__